import { grey } from "designSystem/styles/color";
import { Box, GridRow, Text } from "designSystem/index";
import RichText from "designSystem/components/text/RichText";
import { IndexFunctionComponent } from "designSystem/types/list-types";
import locale from "csi/locale";
import types from "csi/types";
import { observer } from "mobx-react-lite";
import React from "react";
import { usePresentationPopupStore } from "./PresentationPopupStore";

const CanvasNote: IndexFunctionComponent = ({ index }) => {
	const { cache, comments } = usePresentationPopupStore();
	const comment = comments[index];
	const author = cache.get(comment.Author);
	const time = types.formatTime(comment.Date, types.FORMAT_DIFF);

	return (
		<Box
			borderBottom={`1px solid ${grey[400]}`}
			p={1.5}
		>
			<GridRow color={grey[900]} spacing={2}>
				<Text
					lineHeight={16}
					semiBold
					text={locale.getNodeConfiguredName(author, cache)}
				/>
				<Text lineHeight={16} text={time} />
			</GridRow>
			<RichText className="fr-view" value={comment.Comment} />
		</Box>
	);
};

const CanvasNotes = observer(() => {
	const { comments } = usePresentationPopupStore();

	if (!comments.length) {
		return null;
	}

	return (
		<Box textAlign="left">
			{
				comments.map((comment, i) => (
					<CanvasNote index={i} key={comment.$URL} />
				))
			}
		</Box>
	);
});

export default CanvasNotes;